import { useState, useEffect} from 'react'
import { Table,Alert,Row,Col, Button, ProgressBar,Modal,Form} from 'react-bootstrap'
import { InputText, InputTextarea, InputSelect } from './components/Inputs'
import axios from '../../../libs/axios'
import useMohonStore from '../store'
import MohonData from '../components/MohonData'


{/**
  
  Used in MohonItem, when User request the approval
  
  */}
export default function ApprovalModal({id,count,step}) {

    const mohonRequestid = id
    const apiUrl = process.env.REACT_APP_BACKEND_URL
    const store = useMohonStore()
    //const errors = store.errors
    const errors = store.getValue('errors')

    const [error, setError] = useState(false)
    const [show, setShow] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [managers, setManagers] = useState([])
  
    const handleClose = () => setShow(false)
    const handleShow = () => setShow(true)

    const handleShowClick = () =>{
      setShow(true) // show the modal

      // get managers
      axios( `${apiUrl}/user/mohon-approvals/managers`)
      .then ( response => {
        setManagers(response.data.managers)
        //console.log(response)
      })
      .catch ( error => {
        console.warn(error)
      })
      .finally(
      )
    }



    const handleCloseClick = () => {
      handleClose()
    }

    const handleSubmitClick = () => {
      setIsLoading(true)
      
      const formData = new FormData()

      // step = 1 ( user submitted to Pelulus 1)
      //formData.append('step', 1 );

      // method PUT ( to simulate PUT in Laravel )
      formData.append('_method', 'post');


      // append manager_id value
      if (store.getValue('manager_id') != null ) {
        formData.append('manager_id', store.getValue('manager_id'));
      }

      // acknowledge
      if (store.getValue('acknowledge') != null ) {
        formData.append('acknowledge', store.getValue('acknowledge'));
      }

      //console.log(`${store.userApprovalUrl}/${id}`)
      axios({ 
          method: 'post',
          //url : `${store.userApprovalUrl}/${id}`,
          url : `${apiUrl}/user/mohon-approvals/${mohonRequestid}`,
          data: formData
        })
        .then( response => {
          //console.log(response)
          setIsLoading(false)

          store.setValue('refresh', true)
          setTimeout(() => {
            handleCloseClick();
          }, 500);
        })
        .catch( error => {
          console.warn(error)
          setIsLoading(false)
          if(error.response.status === 422){
            store.setValue('errors',  error.response.data.errors )
            
          }
        })
    }

    return (
      <>
        {count === 0 ? (
          <Button disabled  variant="info" onClick={handleShowClick}>
            Mohon
          </Button>
        ) : (
          <Button disabled={step !== 0}  variant="info" onClick={handleShowClick}>
            Mohon
          </Button>
        )}
          
        <Modal size='xl' show={show} onHide={handleCloseClick}>
          <Modal.Header closeButton>
            <Modal.Title>Maklumat Peralatan ( {count} unit )</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <h5>Maklumat Pelulus</h5>
            <InputSelect 
                  fieldName='manager_id' 
                  options = {managers}
                  placeholder='Sila Pilih Ketua Jabatan'  
                  icon='fa-solid fa-person'
                  isLoading={isLoading}
                />
            <br />
            <h5>Maklumat Pemohon</h5>
            <MohonData id={id} />
          </Modal.Body>

          <Modal.Footer>
            <Form.Check
                className='me-4'
                isInvalid={errors?.hasOwnProperty('acknowledge')}
                reverse
                disabled={step !== 0}
                label="Saya mengesahkan telah memeriksa permohonan ini"
                type="checkbox"
                onClick={ () => useMohonStore.setState({errors:null}) }
                onChange={ (e) => store.setValue('acknowledge', true) }
              />
            <Button 
                disabled={isLoading}
                variant="secondary" 
                onClick={handleCloseClick}>
                Tutup
            </Button>

            <Button 
              disabled={step !== 0 || isLoading}
              variant="primary" 
              onClick={handleSubmitClick}>
              Mohon
            </Button>

          </Modal.Footer>
        </Modal>
      </>
    );
  }

